export default "<p>recipes-management works!</p>\r\n"